import React, { useEffect, useState } from "react";
import BillOfMaterialAccordian from "./BillOfMaterialAccordian";
import BomInput from "./BomInput";
import BomOutput from "./BomOutput";
import BomInstallationCost from "./BomInstallationCost";
import BomComment from "./BomComment";
import BomCostOfInputGood from "./BomCostOfInputGood";
import {
  BomHeaderErrorType,
  BomHeaderType,
  BomInputType,
  BomInstallationType,
  BomOutputType,
  BomTotalType,
  IsErrorType,
  PersistInputType,
  SelectOption,
  isAccordianType,
} from "../../../../commonTypes/billOfMaterial";
import toast from "react-hot-toast";
import { connect } from "react-redux";
import {
  AddBatchPayloadType,
  CheckUniqueBatchNumberPayloadType,
  GetAllStockItemListPayloadType,
  GetAutoUniqueNumberPayloadType,
  StockMultipleItemQuantityRatePayloadType,
} from "../../../../commonTypes/clientSettingsTypes";
import {
  addBatchManagementAction,
  checkUniqueBatchNumberAction,
  getAllStockItemListAction,
  getAutoUniqueNumberGenerationAction,
  getMultipleStockItemQuantityAction,
  resetAutoUniqueNumberGenerationData,
  resetBatchNumberUniqueMessage,
  resetClientSettingsError,
  resetClientSettingsSuccess,
  resetMappedStockBatchList,
  resetMappedStockBatchListTotalCount,
  resetMessage,
  resetMultipleStockItemQuantityData,
} from "../../../../redux/clientSettings";
import { RootState } from "../../../../redux/rootReducers";
import {
  postBomDataAction,
  resetUniqueTemplateNameMessage,
  uniqueCheckBOMSavedTemplateNameAction,
  updateBomDataAction,
} from "../../../../redux/invoiceGeneration";
import {
  BomDataPayloadType,
  BomInputGoodsType,
  BomOutputGoodsType,
  UniqueCheckBomTemplateNamePayloadType,
} from "../../../../commonTypes/invoiceGenerationTypes";
import {
  BusinessAddressListType,
  StockItemQuantityRateType,
} from "../../../../redux/clientSettings/clientSettingTypes";
import {
  changeToDecimel,
  formatDate,
  formateDateWithTime,
  handleDate,
} from "../../../../utils/commonFunctions";
import {
  BomInstallationInput,
  InputGoodDataInput,
  OutputGoodDataInput,
} from "../../../../constant/billOfMaterial";
import PrimaryDetails from "./PrimaryDetails";
import { PaperClipIcon } from "../../../Icon";
import { useParams } from "react-router-dom";
import {
  RedDeleteIconWithOutCircle,
  RedErrorIcon,
  Verified,
} from "../../../../assets/images";
import BomAddTemplateModal from "./BomAddTemplateModal";
import useDebounce from "../../../../customHooks/useDebounce";
import BOMTemplateListModal from "../BOMTemplateListModal";
import moment from "moment";
import { useMenuCheck } from "../../../../customHooks/useMenuCheck";
import { Button, OverlayTrigger, Tooltip } from "react-bootstrap";
import Avatar from "../../../commons/CircularAvatar/CircularAvatar";
import AddBatchNumberModal from "./AddBatchNumberModal";
type CheckUniqueErrorType = {
  uniqueNumberError: string;
  isUniqueError: boolean;
};

type AppProps = {
  token: string | null;
  history?: any;
  templateFetching?: boolean;
  isAccordianOpen: isAccordianType;
  inputData: BomInputType[];
  commentData: string;
  template?: string;
  isInputEdit?: string;
  uniqueTemplateNameMessage: string | null;
  total: {
    input: BomTotalType;
    output: BomTotalType;
    totalAdditionalCost?: number;
  };
  stockFetching: boolean;
  currencySign: string | undefined;
  checkStockItemTypeBottom: () => void;
  setStockItemText: any;
  bomHeaderData: BomHeaderType;
  bomInstallationData: BomInstallationType[];
  outputData: BomOutputType[];
  dispatchUpdateBomDataAction: (data: BomDataPayloadType) => void;
  finalStockItemDetailsOptions: SelectOption[];
  setTotal: React.Dispatch<
    React.SetStateAction<{
      input: BomTotalType;
      output: BomTotalType;
    }>
  >;
  type: string;
  templateId?: string;
  offset: number;
  allStockItemList: any;
  isPrimaryChanged?: boolean;
  setOutputData: React.Dispatch<React.SetStateAction<BomOutputType[]>>;
  setInputData: React.Dispatch<React.SetStateAction<BomInputType[]>>;
  setBomInstallationData: React.Dispatch<
    React.SetStateAction<BomInstallationType[]>
  >;
  isQuantityChanged?: boolean;
  multipleStockItemQuantityData: StockItemQuantityRateType[];
  setFinalStockItemDetailsOptions: React.Dispatch<
    React.SetStateAction<SelectOption[] | []>
  >;
  finalStockItemOptions: SelectOption[];
  bomTempHeaderData: BomHeaderType;
  persistHeaderQuantity: number;
  toogleAddTemplateModal?: () => void;
  persistInputType: PersistInputType;
  setPersistInputType: React.Dispatch<React.SetStateAction<PersistInputType>>;
  uploadData: any;
  showUploadModal: () => void;
  setShowImagePreview: React.Dispatch<React.SetStateAction<boolean>>;
  setPersistHeaderQuantity: React.Dispatch<React.SetStateAction<number>>;
  setCommentData: React.Dispatch<React.SetStateAction<string>>;
  setIsError: React.Dispatch<React.SetStateAction<IsErrorType>>;
  isError: IsErrorType;
  bomHeaderError: BomHeaderErrorType;
  businessAddressList: [] | BusinessAddressListType[];
  setBomHeaderError: React.Dispatch<React.SetStateAction<BomHeaderErrorType>>;
  setIsPrimaryChanges?: React.Dispatch<React.SetStateAction<boolean>>;
  setIsQuantityChanges?: React.Dispatch<React.SetStateAction<boolean>>;
  setIsAccordianOpen: React.Dispatch<React.SetStateAction<isAccordianType>>;
  setFinalStockItemOptions: React.Dispatch<
    React.SetStateAction<[] | SelectOption[]>
  >;
  setBomHeaderData: React.Dispatch<React.SetStateAction<BomHeaderType>>;
  setBomTempHeaderData: React.Dispatch<React.SetStateAction<BomHeaderType>>;
  setIsTemplate?: React.Dispatch<React.SetStateAction<boolean>>;
  dispatchGetMultipleStockItemQuantityAction: (
    data: StockMultipleItemQuantityRatePayloadType
  ) => void;
  dispatchResetMultipleStockItemData: () => void;
  dispatchPostBomDataAction: (data: BomDataPayloadType) => void;
  dispatchResetUniqueTemplateNameMessage: () => void;
  dispatchUniqueCheckBOMSavedTemplateNameAction: (
    data: UniqueCheckBomTemplateNamePayloadType
  ) => void;
  handleUseTemplateId?: any;
  singleBomData?: any;
  isEntryLocked: boolean;
  dateOfBom?: any;
  setDateOfBom?: any;
  setIsEntryLocked?: any;
  lockBOMEntriesDate: null | string;
  singleTemplateId?: string;
  approved?: boolean;
  handleApproval?: () => void;
  singleBomDataDetail?: any;
  setFinalBatchNumberOptions: any;
  batchManagementList: any;
  finalBatchNumberOptions: any;
  checkBranchTypeBottom: () => void;
  batchNumberUniqueMessage: string | null;
  batchNumberFetching: boolean;
  dispatchCheckUniqueBatchNumberAction: (
    data: CheckUniqueBatchNumberPayloadType
  ) => void;
  dispatchResetBatchNumberUniqueMessage: () => void;
  dispatchGetAllStockItem: (data: GetAllStockItemListPayloadType) => void;
  dispatchAddBatchManagement: (data: AddBatchPayloadType) => void;
  batchOffset?: number;
  limit: number;
  setBatchOffset?: React.Dispatch<React.SetStateAction<number>>;
  setSelectedStockId: React.Dispatch<React.SetStateAction<string>>;
  setSelectedInputItemStock: React.Dispatch<React.SetStateAction<string>>;
  handletoggleRowInput: (item: number, data: any) => void;
  handletoggleRowOutput: (item: number, data: any) => void;
  handleGetSelectedbatch: (data1: any, data2: any, type: string) => void;
  inputItemBatchIndex: null | number;
  setInputItemBatchIndex: React.Dispatch<React.SetStateAction<null | number>>;
  dispatchGetAutoUniqueNumberCheckAction: (
    data: GetAutoUniqueNumberPayloadType
  ) => void;
  autoUniqueNumberGenerationData: any;
  dispatchResetAutoUniqueNumberGenerationData: () => void;
  batchSuccess: null | number;
  batchError: null | string;
  dropDownType: string;
  setDropDownType: (data: string) => void;
  batchMessage: string | null;
  dispatchResetClientSettingsSuccess: () => void;
  dispatchResetClientSettingsError: () => void;
  dispatchResetClientSettingMessage: () => void;
  dispatchResetMappedStockBatchList: () => void;
  dispatchResetMappedStockBatchListTotalCount: () => void;
  bomType?: string;
  handlePrimaryBatchOpen: () => void;
  isMenuOpen: boolean;
};

const BomAddEditFormDetails = ({
  isAccordianOpen,
  inputData,
  commentData,
  templateFetching,
  history,
  total,
  token,
  uniqueTemplateNameMessage,
  templateId,
  template,
  isPrimaryChanged,
  isQuantityChanged,
  setCommentData,
  bomHeaderError,
  setIsError,
  isError,
  setBomHeaderError,
  setPersistHeaderQuantity,
  businessAddressList,
  setIsPrimaryChanges,
  offset,
  uploadData,
  setIsTemplate,
  showUploadModal,
  allStockItemList,
  setIsQuantityChanges,
  setFinalStockItemOptions,
  bomTempHeaderData,
  persistHeaderQuantity,
  persistInputType,
  finalStockItemOptions,
  setOutputData,
  type,
  stockFetching,
  setShowImagePreview,
  currencySign,
  checkStockItemTypeBottom,
  setStockItemText,
  bomHeaderData,
  outputData,
  finalStockItemDetailsOptions,
  setTotal,
  isInputEdit,
  singleTemplateId,
  bomInstallationData,
  dispatchPostBomDataAction,
  setBomInstallationData,
  setBomHeaderData,
  setBomTempHeaderData,
  setInputData,
  setIsAccordianOpen,
  setPersistInputType,
  handleUseTemplateId,
  multipleStockItemQuantityData,
  dispatchGetMultipleStockItemQuantityAction,
  dispatchResetMultipleStockItemData,
  dispatchUpdateBomDataAction,
  dispatchResetUniqueTemplateNameMessage,
  dispatchUniqueCheckBOMSavedTemplateNameAction,
  singleBomData,
  isEntryLocked,
  dateOfBom,
  setDateOfBom,
  setIsEntryLocked,
  lockBOMEntriesDate,
  approved,
  dropDownType,
  setDropDownType,
  singleBomDataDetail,
  handleApproval,
  setFinalBatchNumberOptions,
  batchManagementList,
  finalBatchNumberOptions,
  checkBranchTypeBottom,
  batchNumberUniqueMessage,
  batchNumberFetching,
  dispatchCheckUniqueBatchNumberAction,
  dispatchResetBatchNumberUniqueMessage,
  dispatchGetAllStockItem,
  dispatchAddBatchManagement,
  batchOffset,
  limit,
  setBatchOffset,
  setSelectedStockId,
  setSelectedInputItemStock,
  handletoggleRowInput,
  handletoggleRowOutput,
  handleGetSelectedbatch,
  inputItemBatchIndex,
  setInputItemBatchIndex,
  dispatchGetAutoUniqueNumberCheckAction,
  autoUniqueNumberGenerationData,
  dispatchResetAutoUniqueNumberGenerationData,
  batchSuccess,
  batchError,
  batchMessage,
  dispatchResetClientSettingsSuccess,
  dispatchResetClientSettingsError,
  dispatchResetClientSettingMessage,
  dispatchResetMappedStockBatchList,
  dispatchResetMappedStockBatchListTotalCount,
  bomType,
  handlePrimaryBatchOpen,
  isMenuOpen
}: AppProps) => {
  const isEditRoute = window.location.pathname.includes("/edit-manufacturing/");
  const company_name =
    history &&
      history.location &&
      history.location.state &&
      history.location.state.company_name
      ? history.location.state.company_name
      : "";
  const { id }: any = useParams();
  const client_code =
    history &&
      history.location &&
      history.location.state &&
      history.location.state.client_code
      ? history.location.state.client_code
      : id;
  const bom_id = history?.location?.state?.bom_id;

  const searchBillOfMaterial = history?.location?.state?.searchBillOfMaterial;
  const filterBillOfMaterial = history?.location?.state?.filterBillOfMaterial;
  const sortingBillOfMaterial = history?.location?.state?.sortingBillOfMaterial;
  const [showAddTemplateModal, setShowAddTemplateModal] = useState(false);
  const [templateName, setTemplateName] = useState("");
  const [showSaveAndTemplateButton, setShowSaveAndTemplateButton] =
    useState(false);
  const [showTemplateList, setShowTemplateList] = useState(false);
  const [isEditManufacturingPresent, setIsEditManufacturingPresent] =
    useMenuCheck();
  const [isAddManufacturingPresent, setIsAddManufacturingPresent] =
    useMenuCheck();
  const [isApprovalManufacturingJournal, setIsApprovalManufacturingJournal] =
    useMenuCheck();
  const [showAddBatchNumberModal, setShowAddBatchNumberModal] =
    useState<boolean>(false);
  const [batchData, setBatchData] = useState<any>({
    batchNumber: "",
    manufacturingDate: "",
    expiryDate: "",
    status: true,
  });

  const [batchUniqueApiMessage, setBatchUniqueApiMessage] =
    useState<string>("");

  const [stockItemName, setStockItemName] = useState<any>({
    value: "",
    label: "Select Stock Name..",
  });
  const [uniqueCheck, setUniqueCheck] =
    useState<CheckUniqueBatchNumberPayloadType>({
      client_code: null,
      token,
      batch_number: undefined,
    });
  const [checkUniqueError, setCheckUniqueError] =
    useState<CheckUniqueErrorType>({
      uniqueNumberError: "",
      isUniqueError: false,
    });
  const { uniqueNumberError } = checkUniqueError;

  const [isPrimaryBatch, setIsPrimaryBatch] = useState(false);

  useEffect(() => {
    dispatchResetUniqueTemplateNameMessage();
    setIsEditManufacturingPresent("Edit Manufacturing", "menu");
    setIsAddManufacturingPresent("Add Manufacturing", "menu");
    setIsApprovalManufacturingJournal("Approve Manufacturing Journal", "menu");
    dispatchResetBatchNumberUniqueMessage();
    dispatchResetAutoUniqueNumberGenerationData();
    dispatchResetMappedStockBatchList();
    dispatchResetMappedStockBatchListTotalCount();
    // setFinalBatchNumberOptions([])


    if (token) {
      let finalData = {
        token,
        clientCode: client_code,
        general_settings_type: "manufacturing_batch_details",
      };
      dispatchGetAutoUniqueNumberCheckAction(finalData);
    }

    /* eslint-disable react-hooks/exhaustive-deps */
  }, []);
  useEffect(() => {
    if (template && template?.length > 0) {
      setShowTemplateList(true);
    }
  }, [template]);

  // useEffect(() => {
  //   if (
  //     batchMessage?.includes("Batch added successfully")
  //   ) {
  //     setIsPrimaryBatch(false)
  //   }
  // }, [batchMessage]);
  useDebounce(
    () => {
      dispatchResetUniqueTemplateNameMessage();
      if (templateName && token) {
        let finalData: any = {
          clientCode: client_code,
          token,
          templateName: templateName?.trim(),
        };
        dispatchUniqueCheckBOMSavedTemplateNameAction(finalData);
      }
    },
    500,
    [templateName]
  );
  useEffect(() => {
    if (
      bomHeaderData?.date &&
      bomHeaderData?.primaryItem?.value &&
      !!+bomHeaderData?.qty &&
      bomHeaderData?.branch?.value
    ) {
      setShowSaveAndTemplateButton(true);
    } else {
      setShowSaveAndTemplateButton(false);
    }
  }, [bomHeaderData]);
  useEffect(() => {
    if (bomHeaderData?.date) {
      if (inputData?.length > 0) {
        let finalStockItemIds: any = [];

        inputData?.map((item: BomInputType) => {
          finalStockItemIds?.push(
            item?.itemName?.value ? item?.itemName?.value : null
          );
        });

        outputData?.map((item: BomOutputType) => {
          finalStockItemIds?.push(
            item?.itemName?.value ? item?.itemName?.value : null
          );
        });

        if (finalStockItemIds?.length > 0) {
          let convertedToString = finalStockItemIds?.join(",")?.toString();
          let stockFinalData = {
            token,
            client_code,
            date: formatDate(bomHeaderData?.date),
            stock_item_ids: convertedToString?.slice(
              0,
              convertedToString?.length
            ),
          };
          dispatchGetMultipleStockItemQuantityAction(stockFinalData);
        } else {
          dispatchResetMultipleStockItemData();
        }
      }
    }
    /* eslint-disable react-hooks/exhaustive-deps */
  }, [bomHeaderData?.date]);

  useEffect(() => {
    if (type === "Add" || (type === "Edit" && isPrimaryChanged)) {
      let finalData: any = [];
      bomHeaderData?.primaryItem?.byProduct?.map((item: any) => {
        if (!!item?.stock_item_id) {
          finalData?.push({ ...item, type: "By-Product" });
        }
      });

      bomHeaderData?.primaryItem?.coProduct?.map((item: any) => {
        if (!!item?.stock_item_id) {
          finalData?.push({ ...item, type: "Co-Product" });
        }
      });

      bomHeaderData?.primaryItem?.scrap?.map((item: any) => {
        if (!!item?.stock_item_id) {
          finalData?.push({ ...item, type: "Scrap" });
        }
      });

      let newFinalData = finalData?.map((item: any) => {
        return {
          itemName: {
            label: item?.stock_item_name,
            value: item?.stock_item_id,
            unit: item?.stock_unit_symbol,
          },
          location: {
            label: "select...",
            value: "",
          },
          quantity: "1",
          percentOfCostAllocation: item?.stock_item_percentage,
          rate: +item.stock_item_percentage * 1,
          amount: (+item.stock_item_percentage * 1)?.toString(),
          stocks: 0,
          type: item?.type,
          unit: item?.stock_unit_symbol,
        };
      });
      setOutputData([...newFinalData]);
    }
    /* eslint-disable react-hooks/exhaustive-deps */
  }, [bomHeaderData?.primaryItem?.value]);

  useEffect(() => {
    let tempOutputData =
      outputData?.length > 0 ? JSON.parse(JSON.stringify(outputData)) : [];

    tempOutputData?.map((item: BomInputType) => {
      item.amount = (
        ((!!total?.input?.amount ? +total?.input?.amount : 0) *
          (!!item?.percentOfCostAllocation
            ? +item?.percentOfCostAllocation
            : 0)) /
        100
      )?.toString();
      item.rate = (
        (item["amount"] ? +item["amount"] : 1) /
        (item.quantity ? +item.quantity : 1)
      )?.toString();
    });
    setOutputData([...tempOutputData]);

    let newInstallationData = bomInstallationData?.length
      ? JSON.parse(JSON.stringify(bomInstallationData))
      : [];
    newInstallationData?.map((item: BomInstallationType, index: number) => {
      if (!!item?.percentage) {
        item.price = ((+total?.input?.amount * +item?.percentage) / 100)
          ?.toFixed(2)
          ?.toString();
      }
    });

    setBomInstallationData([...newInstallationData]);
    /* eslint-disable react-hooks/exhaustive-deps */
  }, [total?.input?.amount]);

  useEffect(() => {
    if (allStockItemList?.length > 0) {
      let newAllStockItemOption = allStockItemList?.map((item: any) => {
        return {
          label: item?.stock_item_name,
          value: item?.stock_item_id,
          unit: item?.stock_unit_symbol,
          byProduct: item?.by_product,
          coProduct: item?.co_product,
          scrap: item?.scrap,
        };
      });

      if (offset > 0) {
        setFinalStockItemOptions([
          ...finalStockItemDetailsOptions,
          ...newAllStockItemOption,
        ]);
      } else {
        setFinalStockItemOptions([...newAllStockItemOption]);
      }
    }
    /* eslint-disable react-hooks/exhaustive-deps */
  }, [allStockItemList]);


  // batch
  useEffect(() => {
    if (
      batchManagementList &&
      // batchManagementList?.length > 0 &&
      (dropDownType !== "InputGoods" && dropDownType !== "OutputGoods" && dropDownType == "primary")
    ) {
      let newBatchOption = batchManagementList?.map((item: any) => {
        return {
          label: item?.batch_number,
          value: item?.batch_id,
          manufacturingDate: item?.manufacturing_date,
          expiryDate: item?.expiry_date,
        };
      });

      setFinalBatchNumberOptions([...newBatchOption]);
    }
    /* eslint-disable react-hooks/exhaustive-deps */
  }, [batchManagementList, inputItemBatchIndex, dropDownType]);

  useEffect(() => {
    if (batchManagementList && batchManagementList?.length > 0) {
      let newBatchOption = batchManagementList?.map((item: any) => {
        return {
          label: item?.batch_number,
          value: item?.batch_id,
          manufacturingDate: item?.manufacturing_date,
          expiryDate: item?.expiry_date,
        };
      });

      if (dropDownType === "InputGoods") {

        setInputData((prevInputData: any) => {
          if (inputItemBatchIndex !== undefined) {
            return prevInputData.map((item: any, index: any) =>
              index === inputItemBatchIndex
                ? { ...item, batchInputOptions: newBatchOption }
                : item
            );
          }
        });
      } else if (dropDownType === "OutputGoods") {
        setOutputData((prevOutputData: any) => {
          if (inputItemBatchIndex !== undefined) {
            return prevOutputData.map((item: any, index: any) =>
              index === inputItemBatchIndex
                ? { ...item, batchInputOptions: newBatchOption }
                : item
            );
          }
        });
      }



    } else {
      setInputData((prevInputData) =>
        prevInputData.map((item) => ({
          ...item,
          batchInputOptions: [],
        }))
      );

      setOutputData((prevInputData) =>
        prevInputData.map((item) => ({
          ...item,
          batchInputOptions: [],
        }))
      );
    }
    /* eslint-disable react-hooks/exhaustive-deps */
  }, [batchManagementList, inputItemBatchIndex, dropDownType]);

  useEffect(() => {
    if (isError?.isItem) {
      toast(
        (t) => (
          <div className="toast-content">
            <span>Please select an item before proceeding to save</span>
            <span className="delete-button" onClick={() => toast.dismiss(t.id)}>
              <img src={RedDeleteIconWithOutCircle} alt="delete" />
            </span>
          </div>
        ),
        {
          duration: 6000,
          position: "top-center",
          style: {
            backgroundColor: "#fef2ed",
            maxWidth: "500px",
            color: "#ba4916",
            border: "1px solid #ba4916",
          },
          icon: <img src={RedErrorIcon} alt="error" />,
          iconTheme: {
            primary: "#000",
            secondary: "#fff",
          },
          ariaProps: {
            role: "status",
            "aria-live": "polite",
          },
        }
      );
    } else if (isError?.isRate) {
      toast(
        (t) => (
          <div className="toast-content">
            <span>
              Please make sure your item has a rate before proceeding to save
            </span>
            <span className="delete-button" onClick={() => toast.dismiss(t.id)}>
              <img src={RedDeleteIconWithOutCircle} alt="delete" />
            </span>
          </div>
        ),
        {
          duration: 6000,
          position: "top-center",
          style: {
            backgroundColor: "#fef2ed",
            maxWidth: "600px",
            color: "#ba4916",
            border: "1px solid #ba4916",
          },
          icon: <img src={RedErrorIcon} alt="error" />,
          iconTheme: {
            primary: "#000",
            secondary: "#fff",
          },
          ariaProps: {
            role: "status",
            "aria-live": "polite",
          },
        }
      );
    }
  }, [isError]);
  useEffect(() => {
    if (outputData?.length > 0) {
      let amount = 0;
      let qty = 0;
      outputData?.map((item: BomOutputType) => {
        amount += +item.amount;
        qty += +item?.quantity;
      });
      setTotal((prev: any) => ({ ...prev, output: { qty, amount } }));
    } else {
      setTotal((prev: any) => ({ ...prev, output: { qty: 0, amount: 0 } }));
    }
    /* eslint-disable react-hooks/exhaustive-deps */
  }, [outputData]);

  useEffect(() => {
    if (type === "Add" || (type === "Edit" && isQuantityChanged)) {
      let tempInputData =
        inputData?.length > 0 ? JSON.parse(JSON.stringify(inputData)) : [];
      let tempOutputData =
        outputData?.length > 0 ? JSON.parse(JSON.stringify(outputData)) : [];

      tempInputData?.map((item: BomInputType, id: number) => {
        let multiplyedValue: number =
          (!!item?.quantity ? +item?.quantity : 0) *
          ((!!bomHeaderData?.qty ? +bomHeaderData?.qty : 0) /
            (!!persistHeaderQuantity ? persistHeaderQuantity : 1));

        let templateMultiplyedValue =
          (item?.singleQty ? +item?.singleQty : 1) * +bomHeaderData?.qty;

        item["quantity"] = !singleTemplateId
          ? !!+multiplyedValue
            ? +changeToDecimel(multiplyedValue)
            : 1
          : singleTemplateId
            ? +changeToDecimel(templateMultiplyedValue)
            : 1;
        item["amount"] = changeToDecimel(
          +(item["quantity"] ? +item["quantity"] : 0) *
          +(item["rate"] ? +item["rate"] : 0)
        )?.toString();
      });
      setInputData([...tempInputData]);

      tempOutputData?.map((item: BomOutputType, id: number) => {
        let multiplyedValue: number =
          (!!item?.quantity ? +item?.quantity : 0) *
          ((!!bomHeaderData?.qty ? +bomHeaderData?.qty : 0) /
            (!!persistHeaderQuantity ? persistHeaderQuantity : 1));

        let templateMultiplyedValue =
          (item?.singleQty ? +item?.singleQty : 1) * +bomHeaderData?.qty;

        item["quantity"] = !singleTemplateId
          ? !!+multiplyedValue
            ? +changeToDecimel(multiplyedValue)
            : 1
          : singleTemplateId
            ? +changeToDecimel(templateMultiplyedValue)
            : 1;
        item["amount"] = (
          (item["quantity"] ? +item["quantity"] : 0) *
          (item["rate"] ? +item["rate"] : 0)
        )?.toString();
      });
      setOutputData([...tempOutputData]);
    }
    /* eslint-disable react-hooks/exhaustive-deps */
  }, [bomHeaderData?.qty]);

  useEffect(() => {
    if (multipleStockItemQuantityData?.length > 0) {
      let newInputData = inputData?.map((item: BomInputType) => {
        let rate = item?.rate;
        let stocks = item?.stocks;
        let amount = item?.amount;
        multipleStockItemQuantityData?.map((multipleItem: any) => {
          if (item?.itemName?.value == multipleItem?.stock_item_id) {
            rate = !!multipleItem?.rate ? multipleItem?.rate?.toString() : "";
            stocks = !!multipleItem?.quantity
              ? multipleItem?.quantity?.toString()
              : "";
            amount = (
              (!!multipleItem?.rate ? +multipleItem?.rate : 0) *
              (!!item?.quantity ? +item?.quantity : 0)
            )?.toString();
          }
        });
        return { ...item, rate, stocks, amount };
      });
      setInputData([...newInputData]);
    }
    /* eslint-disable react-hooks/exhaustive-deps */
  }, [multipleStockItemQuantityData]);

  const addMoreData = (type: string) => {
    let tempInputData =
      inputData?.length > 0 ? JSON.parse(JSON.stringify(inputData)) : [];
    let tempOutputData =
      outputData?.length > 0 ? JSON.parse(JSON.stringify(outputData)) : [];
    let tempInstallationData =
      bomInstallationData?.length > 0
        ? JSON.parse(JSON.stringify(bomInstallationData))
        : [];

    if (type === "InputGoods") {
      tempInputData?.unshift(InputGoodDataInput);
      setInputData(tempInputData);
    } else if (type === "OutputGoods") {
      tempOutputData?.unshift(OutputGoodDataInput);
      setOutputData(tempOutputData);
    } else if (type === "installationCost") {
      tempInstallationData?.unshift(BomInstallationInput);
      setBomInstallationData(tempInstallationData);
    }
  };

  const handleAccordianChange = (type: string) => {
    if (type === "installation") {
      setIsAccordianOpen((prev: isAccordianType) => ({
        ...prev,
        [type]: !isAccordianOpen?.installation,
      }));
    } else if (type === "input") {
      setIsAccordianOpen((prev: isAccordianType) => ({
        ...prev,
        [type]: !isAccordianOpen?.input,
      }));
    } else {
      setIsAccordianOpen((prev: isAccordianType) => ({
        ...prev,
        [type]: !isAccordianOpen?.output,
      }));
    }
  };
  useEffect(() => {
    if (batchNumberUniqueMessage?.length) {
      setBatchUniqueApiMessage(batchNumberUniqueMessage);
    }

    if (
      batchNumberUniqueMessage?.length &&
      batchNumberUniqueMessage?.includes("not")
    ) {
      setCheckUniqueError((prevState) => ({
        ...prevState,
        isUniqueError: true,
      }));
    } else if (
      batchNumberUniqueMessage?.length &&
      !batchNumberUniqueMessage?.includes("not")
    ) {
      setCheckUniqueError((prevState) => ({
        ...prevState,
        isUniqueError: false,
      }));
    }
  }, [batchNumberUniqueMessage]);

  useEffect(() => {
    if (client_code && token) {
      let finalData = {
        token,
        client_code,
      };

      dispatchGetAllStockItem(finalData);
    }
  }, []);
  const option: any = allStockItemList?.map((data: any) => {
    return {
      value: data.stock_item_id,
      label: data.stock_item_name,
    };
  });
  useDebounce(
    () => {
      if (
        uniqueCheck.client_code &&
        uniqueCheck.batch_number &&
        uniqueCheck.token
      ) {
        dispatchCheckUniqueBatchNumberAction(uniqueCheck);
      }
    },
    500,
    [uniqueCheck]
  );

  const handleSubmitBatch = () => {
    let finalData = {
      token,
      clientCode: client_code,
      batchNumber: batchData?.batchNumber,
      expiryDate: batchData?.expiryDate
        ? formatDate(batchData?.expiryDate)
        : "",
      manufacturingDate: batchData?.manufacturingDate
        ? formatDate(batchData?.manufacturingDate)
        : "",
      status: batchData?.status ? 1 : 0,
      stockItem: stockItemName?.value,
    };
    dispatchAddBatchManagement(finalData);
  };

  const handleSetStockItemName = (mode: any) => {
    setStockItemName({
      value: mode?.value,
      label: mode?.label,
    });
  };
  const handleToogleStatusChange = () => {
    setBatchData({
      ...batchData,
      status: !batchData.status,
    });
  };
  const handleBatchNumberChange = (e: any) => {
    handleResetData();
    const { uniqueNumberError } = checkUniqueError;
    let targetName = e.target.name;
    if (targetName === "batchNumber" && e.target.value.length) {
      let finalData = {
        token,
        client_code,
        batch_number: e.target.value,
      };
      if (!id) {
        setUniqueCheck(finalData);
      } else if (id && targetName === "batchNumber") {
        setUniqueCheck(finalData);
        handleResetData();
      } else {
        handleResetData();
        setUniqueCheck({
          client_code: null,
          token,
          batch_number: undefined,
        });
      }
    }

    if (targetName === "batchNumber") {
      setBatchData({
        ...batchData,
        batchNumber: e.target.value,
      });
    }

    if (targetName === "uniqueNumber" && uniqueNumberError) {
      setCheckUniqueError((prevState) => ({
        ...prevState,
        uniqueNumberError: "",
      }));
    }
  };
  const handleManufacturingDateChange = (date: any) => {
    const value = handleDate(date);
    setBatchData({
      ...batchData,
      manufacturingDate: value,
    });
  };
  const handleExpiryDateChange = (date: any) => {
    const value = handleDate(date);
    setBatchData({
      ...batchData,
      expiryDate: value,
    });
  };
  const handleResetData = () => {
    setBatchUniqueApiMessage("");

    setCheckUniqueError({
      uniqueNumberError: "",
      isUniqueError: false,
    });
  };
  const handleDeleteData = (type: string, index: number) => {
    if (type === "InputGoods") {
      let newFilteredInputGoods = inputData?.filter(
        (item: BomInputType, id: number) => id != index
      );
      setInputData(newFilteredInputGoods);
    } else if (type === "OutputGoods") {
      let newFilteredOutputGoods = outputData?.filter(
        (item: BomOutputType, id: number) => id != index
      );
      setOutputData(newFilteredOutputGoods);
    } else if (type === "installationCost") {
      let newFilteredInstallationGoods = bomInstallationData?.filter(
        (item: BomInstallationType, id: number) => id != index
      );
      setBomInstallationData(newFilteredInstallationGoods);
    }
  };

  const toggleAddBatchNumberModal = () => {
    setIsPrimaryBatch(false);
    if (!showAddBatchNumberModal) {
      setBatchData({
        batchNumber: "",
        manufacturingDate: "",
        expiryDate: "",
        status: true,
      });
      setStockItemName({
        value: "",
        label: "Select Stock Name..",
      });
    }

    setShowAddBatchNumberModal(!showAddBatchNumberModal);
  };

  const toggleExpandCollapseItems = (type: string, action: string) => {

    let tempInputData = inputData?.length > 0 ? JSON.parse(JSON.stringify(inputData)) : [];

    let tempOutputData =
      outputData?.length > 0 ? JSON.parse(JSON.stringify(outputData)) : [];

    if (type === "output") {

      let newOutputData = tempOutputData?.map((item: any, idx: number) => ({ ...item, isOpen: action === "collapse" ? false : true }))

      setOutputData([...newOutputData])

    } else if (type === "input") {

      let newInputData = tempInputData?.map((item: any, idx: number) => ({ ...item, isOpen: action === "collapse" ? false : true }))

      setInputData([...newInputData])
    }
  }

  const toogleAddTemplateModal = () => {
    if (showAddTemplateModal) {
      setTemplateName("");
    }
    setShowAddTemplateModal((prev: boolean) => !prev);
  };
  const toogleShowTemplateListModal = () => {
    setShowTemplateList(true);
  };

  const handleShowTemplateListModal = () => {
    setShowTemplateList(!showTemplateList);
  };

  const handleTemplateNameChange = (e: any) => {
    setTemplateName(e.target.value);
  };

  const handlePrimaryDetails = (e: any, primaryType: any) => {
    if (primaryType === "primaryItem") {
      if (e && e?.value) {
        setSelectedStockId(e?.value);
      }

      setInputItemBatchIndex && setInputItemBatchIndex(null);
      setDropDownType && setDropDownType("")
      setIsPrimaryBatch(false);
      setBomHeaderData((prevData: BomHeaderType) => ({
        ...prevData,
        batchNumber: {
          label: "Select...",
          value: null,
          manufacturingDate: "",
          expiryDate: ""
        },

      }));
      setPersistInputType({
        ...persistInputType,
        inputType: type,
        type: "Primary",
        index: "0",
      });
    }

    if (primaryType === "qty") {
      if (type === "Edit") {
        setIsQuantityChanges && setIsQuantityChanges(true);
      }
      setPersistHeaderQuantity(
        +bomHeaderData?.qty > 0 ? +bomHeaderData?.qty : 1
      );
      let value = e.target.value;
      if (!!value) {
        setBomHeaderError((data: BomHeaderErrorType) => ({
          ...data,
          qtyError: false,
        }));
      }

      setBomHeaderData({
        ...bomHeaderData,
        [primaryType]: value < 0 ? 1 : value,
      });
      setBomTempHeaderData({
        ...bomHeaderData,
        [primaryType]: value < 0 ? 1 : value,
      });
    } else if (primaryType === "batchNumber") {
      setBomHeaderData({
        ...bomHeaderData,
        [primaryType]: e,
        manufacturingDate: e.manufacturingDate,
        expiryDate: e.expiryDate,
      });
      setBomTempHeaderData({
        ...bomHeaderData,
        [primaryType]: e,
        manufacturingDate: e.manufacturingDate,
        expiryDate: e.expiryDate,
      });
    } else {
      if (primaryType === "primaryItem" && type === "Edit") {
        setIsPrimaryChanges && setIsPrimaryChanges(true);
      }
      if (primaryType === "date" && !!e) {
        setDateOfBom(moment(e).format("DD-MM-YYYY"));

        setBomHeaderError((data: BomHeaderErrorType) => ({
          ...data,
          dateError: false,
        }));
      } else if (primaryType === "primaryItem" && !!e) {
        setBomHeaderError((data: BomHeaderErrorType) => ({
          ...data,
          primaryItemError: false,
        }));
      } else if (primaryType === "branch" && !!e) {
        setBomHeaderError((data: BomHeaderErrorType) => ({
          ...data,
          branchError: false,
        }));
      }

      setBomHeaderData((prv: any) => ({
        ...prv,
        [primaryType]: e,
      }));
      setBomTempHeaderData((prv: any) => ({
        ...prv,
        [primaryType]: e,
      }));
    }
  };

  const branchOption: SelectOption[] = businessAddressList?.map(
    (item: BusinessAddressListType) => {
      return {
        label: item.trade_name,
        value: item.ledger_id.toString(),
      };
    }
  );

  const handleComment = (e: any) => {
    setCommentData(e.target.value);
  };

  const handleInstallationChange = (e: any, id: number) => {
    let name: string = e.target.name;
    let value: string = e.target.value;
    let newInstallationData: BomInstallationType[] = bomInstallationData?.map(
      (item: BomInstallationType, index: number) => {
        if (index === id) {
          if (name === "percentage") {
            return {
              ...item,
              [name]: value,
              ["price"]: ((+total?.input?.amount * +value) / 100)
                ?.toFixed(2)
                ?.toString(),
            };
          }
          return { ...item, [name]: value };
        } else {
          return item;
        }
      }
    );

    setBomInstallationData(newInstallationData);
  };
  const handleItemGoodBatchChange = (e: any, index: number) => {
    const selectedBatch = e?.value;

    if (type === "InputGoods") {
      const newInputData = inputData.map((item, id) => {
        if (id === index) {
          return {
            ...item,
            batchNumber: selectedBatch,
          };
        }
        return item;
      });
      setInputData(newInputData);
    }
  };
  const handleInputChange = (
    e: any,
    type: string,
    inputType: string,
    index: number
  ) => {
    let value = e;

    if (inputType === "quantity" || inputType === "percentOfCostAllocation") {
      value = e.target.value;
    }

    if (inputType === "itemName") {
      setFinalBatchNumberOptions([])
      // setInputItemBatchIndex&& setInputItemBatchIndex(null)
      // setSelectedStockId(value?.value)
      setSelectedInputItemStock(value?.value);
      if (!!value?.value) {
        setPersistInputType({
          ...persistInputType,
          inputType,
          type,
          index: index?.toString(),
        });
        if (value?.value) {
          let stockFinalData = {
            token,
            client_code,
            date: formatDate(bomHeaderData?.date),
            stock_item_ids: value.value?.toString(),
          };
          dispatchGetMultipleStockItemQuantityAction(stockFinalData);
        } else {
          dispatchResetMultipleStockItemData();
        }
      }
    }

    if (type === "InputGoods") {
      let newInputData = inputData?.map((item: BomInputType, id: number) => {
        if (id === index) {
          if (inputType === "quantity" && +value < 0) {
            return { ...item, [inputType]: 0 };
          }
          if (inputType === "itemName" && !value?.value) {
            return { ...InputGoodDataInput };
          }
          if (inputType === "itemName") {
            return {
              ...item,
              itemName: value,
              batchNumber: {
                label: "Select...",
                value: null,
                manufacturingDate: "",
                expiryDate: ""
              },
            };
          }
          return { ...item, [inputType]: value };
        } else {
          return item;
        }
      });
      setInputData([...newInputData]);
      if (inputType === "quantity") {
        let manuplatedInput = newInputData?.map((item: BomInputType) => {
          return { ...item, amount: (+item.rate * +item.quantity).toString() };
        });
        setInputData([...manuplatedInput]);
      }
    } else if (type === "OutputGoods") {
      let newOutputData = outputData?.map((item: BomOutputType, id: number) => {
        if (id === index) {
          if (inputType === "itemName") {
            return {
              ...item,
              itemName: value,
              batchNumber: {
                label: "Select...",
                value: null,
                manufacturingDate: "",
                expiryDate: ""
              },
            };
          }
          return { ...item, [inputType]: value };
        }

        else {
          return item;
        }
      });
      setOutputData([...newOutputData]);

      if (inputType === "percentOfCostAllocation") {
        let manuplatedOutput = newOutputData?.map((item: BomOutputType) => {
          return {
            ...item,
            amount: (
              ((total?.input?.amount ? +total?.input?.amount : 0) *
                (item?.percentOfCostAllocation
                  ? +item?.percentOfCostAllocation
                  : 0)) /
              100
            )
              ?.toFixed(2)
              ?.toString(),
            rate: (
              (!!(
                ((total?.input?.amount ? +total?.input?.amount : 0) *
                  (item?.percentOfCostAllocation
                    ? +item?.percentOfCostAllocation
                    : 0)) /
                100
              )
                ? +(
                  ((total?.input?.amount ? +total?.input?.amount : 0) *
                    (item?.percentOfCostAllocation
                      ? +item?.percentOfCostAllocation
                      : 0)) /
                  100
                )
                : 0) / (!!item?.quantity ? +item?.quantity : 1)
            )?.toString(),
          };
        });
        setOutputData([...manuplatedOutput]);
      }

      if (inputType === "quantity") {
        let manuplatedOutput = newOutputData?.map((item: BomOutputType) => {
          return { ...item, rate: +item?.quantity ? (+item?.amount / +item?.quantity)?.toFixed(2)?.toString() : "0" };
        });
        setOutputData([...manuplatedOutput]);
      }
    }
  };

  const handleEditInstallation = (id: number) => {
    let tempInstallationData =
      bomInstallationData?.length > 0
        ? JSON.parse(JSON.stringify(bomInstallationData))
        : [];
    tempInstallationData?.map((item: BomInstallationType, index: number) => {
      if (index === id) {
        item.isEditable = !item.isEditable;
      }
    });
    setBomInstallationData(tempInstallationData);
  };

  const handleSubmit = (template?: number) => {
    if (
      bomHeaderData?.date &&
      bomHeaderData?.primaryItem?.value &&
      !!+bomHeaderData?.qty &&
      bomHeaderData?.branch?.value
    ) {
      let isItemFlag = true;
      let isRateFlag = false;
      inputData?.map((item: BomInputType) => {
        if (item?.itemName?.value) {
          isItemFlag = false;
        }
        if (!item?.rate) {
          isRateFlag = true;
        }
      });

      if (isItemFlag || isRateFlag) {
        setIsError({ isRate: isRateFlag, isItem: isItemFlag });
        return;
      }

      let finalInputGoods = inputData?.map((singleItem: BomInputType) => {
        if (singleItem?.itemName?.value) {
          return {
            stock_item_id: singleItem?.itemName?.value
              ? +singleItem?.itemName?.value
              : null,
            stock_item_name: singleItem?.itemName?.label,
            branch_id: singleItem?.location?.value
              ? +singleItem?.location?.value
              : null,
            branch_name: singleItem?.location?.label,
            quantity: singleItem?.quantity ? +singleItem?.quantity : null,
            rate: singleItem?.rate ? +singleItem?.rate : null,
            amount: singleItem?.amount ? +singleItem?.amount : null,
            input_good_batch_id: singleItem?.batchNumber?.value
              ? +singleItem?.batchNumber?.value
              : null,
          };
        } else {
          return null;
        }
      });

      let finalOutputGoods = outputData?.map((singleItem: BomInputType) => {
        if (singleItem?.itemName?.value) {
          return {
            stock_item_id: singleItem?.itemName?.value
              ? +singleItem?.itemName?.value
              : null,
            stock_item_name: singleItem?.itemName?.label,
            stock_item_type: singleItem?.type,
            branch_id: singleItem?.location?.value
              ? +singleItem?.location?.value
              : null,
            branch_name: singleItem?.location?.label,
            quantity: singleItem?.quantity ? +singleItem?.quantity : null,
            rate: singleItem?.rate ? +singleItem?.rate : null,
            amount: singleItem?.amount ? +singleItem?.amount : null,
            percentage_of_cost_of_allocation:
              singleItem?.percentOfCostAllocation
                ? +singleItem?.percentOfCostAllocation
                : null,
            output_good_batch_id: singleItem?.batchNumber?.value
              ? +singleItem?.batchNumber?.value
              : null,
          };
        } else {
          return null;
        }
      });

      let filteredInputGoods: BomInputGoodsType[] = (finalInputGoods || [])
        ?.filter((item) => item !== null)
        .map((item) => {
          if (item && item.branch_name === "Select...") {
            return { ...item, branch_name: "" };
          } else {
            return item;
          }
        }) as BomInputGoodsType[];
      let filteredOutputGoods: BomOutputGoodsType[] = (finalOutputGoods || [])
        ?.filter((item) => item !== null)
        .map((item) => {
          if (item && item.branch_name === "Select...") {
            return { ...item, branch_name: "" };
          } else {
            return item;
          }
        }) as BomOutputGoodsType[];
      let finalAllocation = bomInstallationData?.map(
        (singleItem: BomInstallationType) => {
          return {
            additional_cost_name: singleItem?.itemName,
            additional_cost_gst_percentage: singleItem?.percentage
              ? +singleItem?.percentage
              : null,
            additional_cost_total_amount: singleItem?.price
              ? +singleItem?.price
              : null,
          };
        }
      );

      let finalData = {
        token,
        clientCode: client_code,
        bomId: type === "Add" || isInputEdit?.length ? "" : bom_id,
        bomDate: formatDate(bomHeaderData?.date),
        primaryStockItemId: bomHeaderData?.primaryItem?.value
          ? +bomHeaderData?.primaryItem?.value
          : null,
        primaryStockItemName: bomHeaderData?.primaryItem?.label,
        branchId: bomHeaderData?.branch?.value
          ? +bomHeaderData?.branch?.value
          : null,
        primaryBatchNumber: bomHeaderData?.batchNumber?.value,
        branchName: bomHeaderData?.branch?.label,
        quantity: bomHeaderData?.qty ? +bomHeaderData?.qty : null,
        effectiveCostOfPrimaryItem: (
          +total?.input?.amount +
          (total?.totalAdditionalCost ? +total?.totalAdditionalCost : 0)
        )?.toFixed(2)
          ? +(
            +total?.input?.amount +
            (total?.totalAdditionalCost ? +total?.totalAdditionalCost : 0)
          )?.toFixed(2)
          : null,
        totalAmount: bomHeaderData?.amount ? +bomHeaderData?.amount : null,
        totalCostOfInputGoods: total?.input?.amount
          ? +total?.input?.amount
          : null,
        totalCostOfOutputGoods: total?.output?.amount
          ? +total?.output?.amount
          : null,
        totalAdditionalCost: total?.totalAdditionalCost
          ? +total?.totalAdditionalCost
          : null,
        comment: commentData,
        bomInputGoods: filteredInputGoods,
        bomOutputGoods: filteredOutputGoods,
        bomAdditionalCosts: finalAllocation,
        templateName,
        isTemplate: template,
        effectiveCost:
          +total?.input?.amount +
          (total?.totalAdditionalCost ? +total?.totalAdditionalCost : 0),
        uploads: uploadData,
        rateOfPrimaryItem:
          (+(
            +total?.input?.amount +
            (total?.totalAdditionalCost ? +total?.totalAdditionalCost : 0)
          ) -
            +total?.output?.amount) /
          (!!bomHeaderData?.qty ? +bomHeaderData?.qty : 1),
      };
      if (template) {
        setIsTemplate?.(true);
      }
      type === "Add" || isInputEdit?.length
        ? dispatchPostBomDataAction(finalData)
        : dispatchUpdateBomDataAction(finalData);
    } else {
      if (!!bomHeaderData?.date) {
        setBomHeaderError((prev: BomHeaderErrorType) => ({
          ...prev,
          dateError: false,
        }));
      }
      if (!bomHeaderData?.date) {
        setBomHeaderError((prev: BomHeaderErrorType) => ({
          ...prev,
          dateError: true,
        }));
      }

      if (!!bomHeaderData?.branch?.value) {
        setBomHeaderError((prev: BomHeaderErrorType) => ({
          ...prev,
          branchError: false,
        }));
      }
      if (!bomHeaderData?.branch?.value) {
        setBomHeaderError((prev: BomHeaderErrorType) => ({
          ...prev,
          branchError: true,
        }));
      }

      if (!bomHeaderData?.primaryItem?.value) {
        setBomHeaderError((prev: BomHeaderErrorType) => ({
          ...prev,
          primaryItemError: true,
        }));
      }
      if (bomHeaderData?.primaryItem?.value) {
        setBomHeaderError((prev: BomHeaderErrorType) => ({
          ...prev,
          primaryItemError: false,
        }));
      }

      if (!!+bomHeaderData?.qty) {
        setBomHeaderError((prev: BomHeaderErrorType) => ({
          ...prev,
          qtyError: false,
        }));
      }
      if (!+bomHeaderData?.qty) {
        setBomHeaderError((prev: BomHeaderErrorType) => ({
          ...prev,
          qtyError: true,
        }));
      }
    }
  };

  return (
    <div>
      <PrimaryDetails
        currencySign={currencySign}
        option={branchOption}
        allStockItemOption={finalStockItemDetailsOptions}
        bomHeaderData={bomHeaderData}
        bomHeaderError={bomHeaderError}
        fetching={stockFetching}
        templateId={templateId ? templateId : ""}
        checkStockItemTypeBottom={checkStockItemTypeBottom}
        setStockItemText={setStockItemText}
        setDateOfBom={setDateOfBom}
        handlePrimaryDetails={handlePrimaryDetails}
        allBatchOption={finalBatchNumberOptions}
        toggleAddBatchNumberModal={toggleAddBatchNumberModal}
        autoUniqueNumberGenerationData={autoUniqueNumberGenerationData}
        limit={limit}
        bomType={bomType}
        setDropDownType={setDropDownType}
        dispatchResetMappedStockBatchList={dispatchResetMappedStockBatchList}
        handlePrimaryBatchOpen={handlePrimaryBatchOpen}
        batchFetching={batchNumberFetching}
        isMenuOpen={isMenuOpen}

      />

      <div className="d-flex bom_container">
        <div className="input_output">
          <BillOfMaterialAccordian
            title="INPUT ITEM"
            count="01"
            type="input"
            isAccordianOpen={isAccordianOpen}
            handleAccordianChange={handleAccordianChange}
          />
          {isAccordianOpen?.input ? (
            <BomInput
              branchOption={branchOption}
              templateId={templateId ? templateId : ""}
              bomHeaderData={bomHeaderData}
              inputData={inputData}
              addMoreData={addMoreData}
              deleteData={handleDeleteData}
              handleComment={handleComment}
              commentData={commentData}
              currencySign={currencySign}
              fetching={stockFetching}
              checkStockItemTypeBottom={checkStockItemTypeBottom}
              setStockItemText={setStockItemText}
              handleInputChange={handleInputChange}
              allStockItemOption={finalStockItemDetailsOptions}
              total={total}
              setTotal={setTotal}
              handlePrimaryDetails={handleItemGoodBatchChange}
              checkBranchTypeBottom={checkBranchTypeBottom}
              allBatchOption={finalBatchNumberOptions}
              handletoggleRowInput={handletoggleRowInput}
              handleGetSelectedbatch={handleGetSelectedbatch}
              autoUniqueNumberGenerationData={autoUniqueNumberGenerationData}
              toggleExpandCollapseItems={toggleExpandCollapseItems}
              batchFetching={batchNumberFetching}
              isMenuOpen={isMenuOpen}

            />
          ) : null}

          <BillOfMaterialAccordian
            title="OTHER OUTPUT ITEM"
            count="02"
            type="output"
            isAccordianOpen={isAccordianOpen}
            handleAccordianChange={handleAccordianChange}
          />
          {isAccordianOpen?.output ? (
            <BomOutput
              total={total}
              setTotal={setTotal}
              branchOption={branchOption}
              outputData={outputData}
              templateId={templateId ? templateId : ""}
              addMoreData={addMoreData}
              deleteData={handleDeleteData}
              setBomInstallationData={setBomInstallationData}
              fetching={stockFetching}
              currencySign={currencySign}
              setBomHeaderData={setBomHeaderData}
              setBomTempHeaderData={setBomTempHeaderData}
              checkStockItemTypeBottom={checkStockItemTypeBottom}
              setStockItemText={setStockItemText}
              allStockItemOption={finalStockItemDetailsOptions}
              bomInstallationData={bomInstallationData}
              bomHeaderData={bomHeaderData}
              handleInputChange={handleInputChange}
              handletoggleRowInput={handletoggleRowOutput}
              handleEditInstallation={handleEditInstallation}
              handleGetSelectedbatch={handleGetSelectedbatch}
              handleInstallationChange={handleInstallationChange}
              autoUniqueNumberGenerationData={autoUniqueNumberGenerationData}
              toggleExpandCollapseItems={toggleExpandCollapseItems}
              batchFetching={batchNumberFetching}
              isMenuOpen={isMenuOpen}

            />
          ) : null}

          <BillOfMaterialAccordian
            title="ADDITIONAL COST"
            count="03"
            type="installation"
            isAccordianOpen={isAccordianOpen}
            handleAccordianChange={handleAccordianChange}
          />
          {isAccordianOpen?.installation ? (
            <div className="installation">
              <BomInstallationCost
                data={bomInstallationData}
                total={total}
                templateId={templateId ? templateId : ""}
                setBomInstallationData={setBomInstallationData}
                deleteData={handleDeleteData}
                addMoreData={addMoreData}
                handleEdit={handleEditInstallation}
                handleInstallationChange={handleInstallationChange}
              />
            </div>
          ) : null}
        </div>

        <div style={{ width: "28vw" }}>
          <div className="commentHeader">
            <div className="costOfInputHeader">COMMENT</div>
          </div>
          <div className="comment">
            <BomComment
              templateId={templateId ? templateId : ""}
              handleComment={handleComment}
              commentData={commentData}
            />
          </div>

          <div className="costOfInputGoods">
            <BomCostOfInputGood
              total={total}
              currencySign={currencySign}
              setTotal={setTotal}
              setBomHeaderData={setBomHeaderData}
              setBomTempHeaderData={setBomTempHeaderData}
              bomInstallationData={bomInstallationData}
              bomHeaderData={bomHeaderData}
            />
          </div>
        </div>
      </div>
      {/* Future use */}
      {isEditRoute && isApprovalManufacturingJournal && (
        <div className="card mt-2">
          <div className="card-body">
            <div className="approve-details">
              <div>
                <h6>Approval Details</h6>
                {
                  <div>
                    {
                      <Button
                        disabled={approved}
                        className="mr-2"
                        onClick={() => {
                          handleApproval?.();
                        }}
                      >
                        <img src={Verified} alt="verified" />
                        {approved ? "Approved" : " Approve This Entry"}
                      </Button>
                    }
                  </div>
                }
              </div>
              <div>
                {singleBomDataDetail?.approval_details?.length > 0 && (
                  <p>Previously approved by</p>
                )}
                <div style={{ display: "flex", gap: "3%" }}>
                  {singleBomDataDetail?.approval_details?.length > 0 &&
                    singleBomDataDetail?.approval_details?.map(
                      (approvalProfile: any) => {
                        let fullName =
                          approvalProfile?.first_name +
                          " " +
                          approvalProfile?.last_name;
                        return (
                          <OverlayTrigger
                            placement="top"
                            delay={{ show: 250, hide: 250 }}
                            overlay={
                              <Tooltip id="button-view-open-item">
                                {fullName}
                                <br></br>
                                approved on{" "}
                                {formateDateWithTime(
                                  approvalProfile?.approved_at
                                )}
                              </Tooltip>
                            }
                          >
                            <span>
                              {" "}
                              <Avatar
                                name={fullName}
                                image={approvalProfile?.profile_pic?.file_url}
                              />
                            </span>
                          </OverlayTrigger>
                        );
                      }
                    )}
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {showAddTemplateModal ? (
        <BomAddTemplateModal
          showAddTemplateModal={showAddTemplateModal}
          toogleAddTemplateModal={toogleAddTemplateModal}
          templateName={templateName}
          templateFetching={templateFetching}
          handleAddTemplate={handleSubmit}
          uniqueTemplateNameMessage={
            uniqueTemplateNameMessage ? uniqueTemplateNameMessage : ""
          }
          handleTemplateNameChange={handleTemplateNameChange}
        />
      ) : null}
      {showTemplateList ? (
        <BOMTemplateListModal
          showAddTemplateModal={showTemplateList}
          toogleAddTemplateModal={handleShowTemplateListModal}
          templateFetching={stockFetching}
          history={history}
          handleUseTemplateId={handleUseTemplateId}
        />
      ) : null}

      {!templateId ? (
        <div className="cancelSaveBtn">
          <div className="col-md-4 mt-1 mb-3 mt-4 d-flex p-0">
            <div>
              <p
                style={{
                  fontSize: "15px",
                  fontWeight: "600",
                  marginBottom: "11px",
                  textAlign: "left",
                }}
              >
                UPLOAD MANUFACTURING FILES
              </p>
              <div style={{ display: "flex", alignItems: "center" }}>
                <button
                  className="btn btn-outline"
                  onClick={() => {
                    showUploadModal();
                  }}
                >
                  + Upload File
                </button>
                <div className="pointer position-relative ml-4">
                  {uploadData?.length ? (
                    <span
                      id="Popover1"
                      onClick={() => setShowImagePreview(true)}
                    >
                      <PaperClipIcon />
                      <span
                        className="badge count-badge"
                        style={{ left: "11px" }}
                      >
                        {uploadData?.length}
                      </span>
                    </span>
                  ) : (
                    ""
                  )}
                </div>
              </div>
            </div>
          </div>

          <div>
            <button
              className="btn mr-3"
              style={{ border: "1px solid #bfcbe1", marginRight: "15px" }}
              onClick={() => {
                toast.remove();
                history.push({
                  pathname: `/invoice-generation/${client_code}#manufacturing`,
                  state: {
                    client_code,
                    company_name,
                    searchBillOfMaterial,
                    filterBillOfMaterial,
                    sortingBillOfMaterial,
                  },
                });
              }}
            >
              {isEditManufacturingPresent && !isEntryLocked ? `Cancel` : `Exit`}
            </button>

            {
              // type === "Add" || isInputEdit?.length  && singleBomData?.is_lock==0 &&!isEntryLocked ?
              !singleBomData?.is_lock &&
                !isEntryLocked &&
                (type === "Add" || isInputEdit?.length) ? (
                <button
                  className="btn btn-primary mr-2 ml-2"
                  onClick={toogleAddTemplateModal}
                  disabled={!showSaveAndTemplateButton}
                >
                  Submit & Save Template
                </button>
              ) : null
            }
            {
              // singleBomData?.is_lock==0 &&!isEntryLocked ?
              // (isAddManufacturingPresent || isEditManufacturingPresent) &&

              !singleBomData?.is_lock && !isEntryLocked ? (
                <button
                  className="btn btn-primary"
                  onClick={() => handleSubmit()}
                  disabled={!showSaveAndTemplateButton}
                >
                  {type === "Add" || isInputEdit?.length ? "Submit" : "Submit"}
                </button>
              ) : null
            }
          </div>
        </div>
      ) : null}

      {showAddBatchNumberModal && (
        <AddBatchNumberModal
          showAddBatchNumberModal={showAddBatchNumberModal}
          toggleAddBatchNumberModal={toggleAddBatchNumberModal}
          handleBatchNumberChange={handleBatchNumberChange}
          batchData={batchData}
          handleManufacturingDateChange={handleManufacturingDateChange}
          handleExpiryDateChange={handleExpiryDateChange}
          uniqueNumberError={uniqueNumberError}
          batchNumberFetching={batchNumberFetching}
          batchNumberUniqueMessage={batchNumberUniqueMessage}
          option={option}
          stockItemName={stockItemName}
          handleSetStockItemName={handleSetStockItemName}
          handleToogleStatusChange={handleToogleStatusChange}
          handleSubmitBatch={handleSubmitBatch}
        />
      )}
    </div>
  );
};

const mapStateToProps = (state: RootState) => ({
  token: state.auth.token,
  fetching: state.invoiceGeneration.fetching,
  success: state.invoiceGeneration.success,
  error: state.invoiceGeneration.error,
  message: state.invoiceGeneration.message,
  statuscode: state.invoiceGeneration.statusCode,
  businessAddressList: state.clientSettings.businessAddressList,
  allStockItemList: state.clientSettings.allStockItemList,
  stockFetching: state.clientSettings.fetching,
  singleBomData: state.invoiceGeneration.singleBomData,
  currencySign: state.auth.currencySign,
  stockItemListTotal: state.clientSettings.stockItemListTotal,
  multipleStockItemQuantityData:
    state.clientSettings.multipleStockItemQuantityData,
  uniqueTemplateNameMessage: state.invoiceGeneration.uniqueTemplateNameMessage,
  templateFetching: state.invoiceGeneration.templateFetching,
  lockBOMEntriesDate: state.invoiceGeneration.lockBOMEntriesDate,
  batchNumberUniqueMessage: state.clientSettings.batchNumberUniqueMessage,
  batchNumberFetching: state.clientSettings.fetching,
  autoUniqueNumberGenerationData:
    state.clientSettings.autoUniqueNumberGenerationData,
  batchSuccess: state.clientSettings.success,
  batchError: state.clientSettings.error,
  batchMessage: state.clientSettings.message,
});

const mapDispatchToProps = (dispatch: any) => ({
  dispatchGetMultipleStockItemQuantityAction: (
    data: StockMultipleItemQuantityRatePayloadType
  ) => dispatch(getMultipleStockItemQuantityAction(data)),
  dispatchResetMultipleStockItemData: () =>
    dispatch(resetMultipleStockItemQuantityData()),
  dispatchResetUniqueTemplateNameMessage: () =>
    dispatch(resetUniqueTemplateNameMessage()),
  dispatchUpdateBomDataAction: (data: BomDataPayloadType) =>
    dispatch(updateBomDataAction(data)),
  dispatchPostBomDataAction: (data: BomDataPayloadType) =>
    dispatch(postBomDataAction(data)),
  dispatchUniqueCheckBOMSavedTemplateNameAction: (
    data: UniqueCheckBomTemplateNamePayloadType
  ) => dispatch(uniqueCheckBOMSavedTemplateNameAction(data)),
  dispatchCheckUniqueBatchNumberAction: (
    data: CheckUniqueBatchNumberPayloadType
  ) => dispatch(checkUniqueBatchNumberAction(data)),
  dispatchResetBatchNumberUniqueMessage: () =>
    dispatch(resetBatchNumberUniqueMessage()),
  dispatchGetAllStockItem: (data: GetAllStockItemListPayloadType) =>
    dispatch(getAllStockItemListAction(data)),
  dispatchAddBatchManagement: (data: AddBatchPayloadType) =>
    dispatch(addBatchManagementAction(data)),
  dispatchGetAutoUniqueNumberCheckAction: (
    data: GetAutoUniqueNumberPayloadType
  ) => dispatch(getAutoUniqueNumberGenerationAction(data)),
  dispatchResetAutoUniqueNumberGenerationData: () =>
    dispatch(resetAutoUniqueNumberGenerationData()),
  dispatchResetClientSettingsSuccess: () =>
    dispatch(resetClientSettingsSuccess()),
  dispatchResetClientSettingsError: () => dispatch(resetClientSettingsError()),
  dispatchResetClientSettingMessage: () => dispatch(resetMessage()),
  dispatchResetMappedStockBatchList: () =>
    dispatch(resetMappedStockBatchList()),
  dispatchResetMappedStockBatchListTotalCount: () =>
    dispatch(resetMappedStockBatchListTotalCount()),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(BomAddEditFormDetails);
